import React from "react";
import Banner from "../components/AboutUs/Banner";
import OurJourney from "../components/AboutUs/OurJourney";
import Headline from "../components/AboutUs/Headline";
import VisionMission from "../components/AboutUs/VisionMission";
import OurTeam from "../components/AboutUs/OurTeam";
import MeetOurTeam from "../components/AboutUs/MeetOurTeam";

const AboutUs = () => {
  return (
    <>
      <Banner />
      <OurJourney />
      <Headline />
      <VisionMission />
      <OurTeam />
      <MeetOurTeam />
    </>
  );
};

export default AboutUs;

// import React, { useState, useEffect, useRef } from "react";
// import Banner from "../components/AboutUs/Banner";
// import OurJourney from "../components/AboutUs/OurJourney";
// import Headline from "../components/AboutUs/Headline";
// import VisionMission from "../components/AboutUs/VisionMission";
// import OurTeam from "../components/AboutUs/OurTeam";
// import MeetOurTeam from "../components/AboutUs/MeetOurTeam";

// const AboutUs = () => {
//   const [scrollProgress, setScrollProgress] = useState(0);
//   const sectionRefs = useRef([]);

//   // Define groups of sections with start & end colors
//   const sectionGroups = [
//     {
//       sections: ["Banner", "OurJourney"],
//       start: [161, 164, 200], // #A1A4C8
//       end: [255, 255, 255],   // white
//     },
//     {
//       sections: ["Headline", "VisionMission", "OurTeam"],
//       start: [255, 255, 255], // white
//       end: [255, 237, 169],   // #FFEDA9
//     },
//     {
//       sections: ["MeetOurTeam"],
//       start: [161, 164, 200], // #A1A4C8
//       end: [255, 255, 255],   // white
//     },
//   ];

//   useEffect(() => {
//     const handleScroll = () => {
//       const scrollY = window.scrollY;
//       const viewportHeight = window.innerHeight;

//       for (let i = 0; i < sectionRefs.current.length; i++) {
//         const section = sectionRefs.current[i];
//         if (!section) continue;

//         const rect = section.getBoundingClientRect();
//         const sectionTop = rect.top + scrollY;
//         const sectionHeight = rect.height;

//         // Check if this section group is in viewport
//         if (
//           scrollY >= sectionTop - viewportHeight &&
//           scrollY < sectionTop + sectionHeight
//         ) {
//           const progress = Math.min(
//             Math.max((scrollY - sectionTop) / sectionHeight, 0),
//             1
//           );
//           setScrollProgress({ groupIndex: i, progress });
//           break;
//         }
//       }
//     };

//     window.addEventListener("scroll", handleScroll);
//     handleScroll();
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   // Calculate current background color
//   const getBackground = () => {
//     const { groupIndex = 0, progress = 0 } = scrollProgress;
//     const group = sectionGroups[groupIndex] || sectionGroups[0];

//     const currentColor = group.start.map((start, i) =>
//       Math.round(start + (group.end[i] - start) * progress)
//     );

//     return `rgb(${currentColor.join(",")})`;
//   };

//   return (
//     <div style={{ background: getBackground(), transition: "background 0.1s linear" }}>
//       {/* Group 1 */}
//       <div ref={(el) => (sectionRefs.current[0] = el)}>
//         <Banner />
//         <OurJourney />
//       </div>

//       {/* Group 2 */}
//       <div ref={(el) => (sectionRefs.current[1] = el)}>
//         <Headline />
//         <VisionMission />
//         <OurTeam />
//       </div>

//       {/* Group 3 */}
//       <div ref={(el) => (sectionRefs.current[2] = el)}>
//         <MeetOurTeam />
//       </div>
//     </div>
//   );
// };

// export default AboutUs;

